import { Box, Button, Grid, Typography, useTheme } from "@mui/material"
import useAuth from "../../../../../../context/auth"
import { usePageTitle } from "../../../../../../hooks"
import { BsCheckCircle } from "react-icons/bs"
import { ModalCongratulationsWithdraw } from "../modal/congratulations"
import { useEffect, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { PayDailys } from "../modal/payDailys"
import { SelectPIXModal } from "../../../../../simulator/modal/pix"
import { Format } from "../../../../../../utils"
import { HiOutlineCurrencyDollar } from "react-icons/hi2"
import { PartnerService } from "../../../../../../services/partner"
import { IMovements } from "../../../../../partner/extract"

export const Rewards = () => {
    usePageTitle("Indique e ganhe - ganhos")
    const { user, handleBack, handleIndicationTab, getData } = useAuth()
    const { palette } = useTheme()
    const [openModalCongratulations, setOpenModalCongratulations] = useState(false)
    const [openModalPayDaily, setOpenModalPayDaily] = useState(false)
    const [openPIX, setOpenPIX] = useState(false)
    const [loading, setLoading] = useState(false)

    const [movements, setMovements] = useState<IMovements[]>([])

    const amounts = {
        available: {
            qtd: movements?.filter((item) => item.value > 0).length - movements?.filter((item) => item.value < 0).length,
            value: movements?.filter((item) => item.value > 0).reduce((prev, current) => prev + current.value, 0) - (movements?.filter((item) => item.value < 0).reduce((prev, current) => prev + current.value, 0) * -1)
        },
        paid: {
            qtd: movements?.filter((item) => item.value < 0).length,
            value: movements?.filter((item) => item.value < 0).reduce((prev, current) => prev + current.value, 0)
        }
    }

    const withdraw = (to: "cpf" | "cnpj") => {
        setLoading(true)
        PartnerService.withdraw({
            accountId: user?.account?.id as number,
            toKey: to,
        })
            .then(() => {
                setOpenModalCongratulations(true)
            })
            .finally(() => {
                setLoading(false)
                getData()
                getMovements()
            })
    }

    const getMovements = () => {
        setLoading(true)
        PartnerService.getMovements(user?.account?.id as number)
            .then(({ data }) => {
                setMovements(data?.movements?.rows)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getMovements()
    }, [])

    return (
        <Grid
            display={"flex"}
            direction={"column"}
            gap={"2rem"}
            width={"100%"}
            height={"100%"}
        >
            <Typography
                fontSize={"4.88rem"}
                fontFamily={"Nexa Heavy"}
                fontWeight={900}
                sx={{
                    background: "linear-gradient(90deg, #1D22E6 0%, #01E9FE 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                }}
            >
                Ganhos
            </Typography>

            <Box
                display={"flex"}
                flexDirection={"row"}
                gap={"2rem"}
                justifyContent={"space-between"}
                padding={"2rem 1rem"}
                boxSizing={"border-box"}
                width={"100%"}
                sx={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px"
                }}
            >
                <Grid
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Typography fontSize={"1.6rem"} fontWeight={400} color="#49454F">Saldo disponível</Typography>
                    <Typography fontSize={"3.2rem"} lineHeight={"3.5rem"} fontWeight={900} color="#49B84F">{Format.currency(user?.account?.balance ?? 0)}</Typography>
                </Grid>
                <Grid
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <LoadingButton
                        variant="contained"
                        sx={{
                            width: "11.1rem",
                            height: "3.5rem",
                            fontSize: "1.4rem"
                        }}
                        onClick={() => {
                            if (user?.actualContract?.parcels?.find((item) => item.status === 5)) {
                                setOpenModalPayDaily(true)
                            } else {
                                setOpenPIX(true)
                            }
                        }}
                        loading={loading}
                        disabled={(user?.account?.balance ?? 0) <= 0}
                    >
                        Sacar
                    </LoadingButton>
                </Grid>
            </Box>

            <Grid
                width={"100%"}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
            >
                <Button
                    variant="text"
                    sx={{
                        textDecoration: "underline",
                        backgroundColor: "#178BF10D",
                        width: "15.1rem",
                        height: "3.2rem",
                    }}
                    onClick={() => handleIndicationTab("extract")}
                >
                    Conferir extrato
                </Button>
            </Grid>

            <Box
                display={"flex"}
                flexDirection={"row"}
                gap={".5rem"}
                justifyContent={"space-between"}
                padding={"1rem"}
                boxSizing={"border-box"}
                width={"100%"}
                mt={"2rem"}
                sx={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px"
                }}
            >
                <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={".3rem"}
                >
                    <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        width={"5.5rem"}
                        height={"5.5rem"}
                        sx={{
                            backgroundColor: "#49B84F1A",
                            borderRadius: "100%"
                        }}
                    >
                        <HiOutlineCurrencyDollar size={"3rem"} color="#106C1E" />
                    </Grid>

                    <Grid
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={400}>{amounts.available.qtd} contrato{amounts.available.qtd !== 1 && "s"}</Typography>
                        <Typography fontSize={"2rem"} lineHeight={"2.4rem"} fontWeight={600}>disponíve{amounts.available.qtd !== 1 ? "is" : "l"}</Typography>
                    </Grid>
                </Grid>
                <Grid
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-end"}
                    justifyContent={"center"}
                >
                    <Typography fontSize={"2.4rem"} fontWeight={700} color="#49B84F" lineHeight={"2.9rem"}>{Format.currencyWithoutDecimals(amounts.available.value)}</Typography>
                    <Typography fontSize={"1.4rem"} lineHeight={"1.6rem"} fontWeight={400} color="#49B84F">disponível</Typography>
                </Grid>
            </Box>

            <Box
                display={"flex"}
                flexDirection={"row"}
                gap={".5rem"}
                justifyContent={"space-between"}
                padding={"1rem"}
                boxSizing={"border-box"}
                width={"100%"}
                sx={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px"
                }}
            >
                <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={".3rem"}
                >
                    <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        width={"5.5rem"}
                        height={"5.5rem"}
                        sx={{
                            backgroundColor: "rgb(69 162 243 / 15%)",
                            borderRadius: "100%"
                        }}
                    >
                        <BsCheckCircle size={"2.5rem"} color={palette.primary.dark} />
                    </Grid>

                    <Grid
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={400}>{amounts.paid.qtd} contrato{amounts.paid.qtd !== 1 && "s"}</Typography>
                        <Typography fontSize={"2rem"} lineHeight={"2.4rem"} fontWeight={600}>pago{amounts.paid.qtd !== 1 && "s"}</Typography>
                    </Grid>
                </Grid>
                <Grid
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-end"}
                    justifyContent={"center"}
                >
                    <Typography fontSize={"2.4rem"} fontWeight={700} color={palette.primary.main} lineHeight={"2.9rem"}>{Format.currencyWithoutDecimals(amounts.paid.value < 0 ? amounts.paid.value * -1 : 0)}</Typography>
                    <Typography fontSize={"1.4rem"} lineHeight={"1.6rem"} fontWeight={400} color={palette.primary.main}>pago</Typography>
                </Grid>
            </Box>

            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem"
                    }}
                    variant="outlined"
                    onClick={handleBack}
                >Voltar</Button>
            </Grid>

            <ModalCongratulationsWithdraw open={openModalCongratulations} onClose={() => setOpenModalCongratulations(false)} />
            <PayDailys open={openModalPayDaily} onClose={() => setOpenModalPayDaily(false)} />
            <SelectPIXModal
                open={openPIX}
                onSelect={(value) => {
                    setOpenPIX(false)
                    withdraw(value)

                }}
                onClose={() => setOpenPIX(false)}
            />
        </Grid>
    )
}